<template>
    <div class="loader-container" v-if="pageLoader">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Loading Details</span>
    </div>
    <div v-else class="vision-brief-container">
        <div class="generated-theme-wrapper">
            <div class="theme-header">
                <p class="static-qn">Article Suggestions</p>
                <p class="sub-txt">[Pick an article theme that fits your goal.]</p>
            </div>

            <div class="theme-grid-container">
                <div class="grid-card" v-for="(suggestion, index) in suggestedArticles"
                    :class="{ active: suggestion.isSelected }" @click="selectSuggestion(index)">
                    <p v-if="suggestion.isSelected" class="selected-txt">SELECTED</p>
                    <div class="theme-top">
                        <p class="theme-title">{{ suggestion.title }}</p>
                        <p class="theme-value">Summary</p>
                        <p class="theme-description">{{ suggestion.summary }}</p>
                        <p class="theme-value">Value</p>
                        <p class="theme-description">{{ suggestion.value }}</p>
                        <p class="theme-value">Storytelling Angle</p>
                        <p class="theme-description">{{ suggestion.angle }}</p>
                    </div>
                    <div class="theme-bottom">
                        <p class="theme-cta">Call-to-Action</p>
                        <p class="theme-description">{{ suggestion.cta }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RotatingLoader from '@/components/CircularProgressBar.vue'
import axiosInstance from '@/axiosInterceptor';
export default {
    components: {
       RotatingLoader
    },
    data() {
        return {
            pageLoader: false,
            suggestedArticles: [],
            selectedArticle: null,
            isFormValid: false
        }

    },

    watch: {
        suggestedArticles: {
            deep: true,
            handler(newValue) {
                this.$emit('suggest-article-data', newValue);
            }
        }
    },

    methods: {
        selectSuggestion(index) {
            this.suggestedArticles.forEach(article => {
                article.isSelected = false;
            });
            this.suggestedArticles[index].isSelected = true;
            this.selectedArticle = { ...this.suggestedArticles[index] };
            this.$emit('article-selected', this.selectedArticle);
            this.isFormValid = true;
        },
        async getArticleData() {
            this.pageLoader = true;
            try {
                const response = await axiosInstance.get(`/article/${this.$route.params.articleId}`);
                if (response.status === 200) {
                    const suggestions = response.data.data.suggestArticles;
                    this.suggestedArticles = [
                        suggestions.articleOne,
                        suggestions.articleTwo,
                        suggestions.articleThree
                    ].filter(article => article && article.title)
                    .map(article => ({ 
                        ...article,
                        isSelected: article.isSelected ?? false
                    }));
                }
            } catch (error) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Error fetching article details',
                });
            } finally {
                this.pageLoader = false;
            }
        }

    },
    async mounted() {
        this.pageLoader = true;
        await this.getArticleData();
        this.pageLoader = false;
    }
}
</script>

<style scoped>
.vision-brief-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    padding: 24px 8px 40px 8px;
    overflow-y: auto;
    max-height: 100vh;
    scrollbar-width: thin; 
    will-change: transform; 
}

.static-qn {
    font-size: var(--header-font-size);
    font-weight: 600;
    text-align: left;
    color: #FAFAFA;
    width: 50%;
}

.sub-txt {
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF99;
    font-style: italic;
}

.generated-theme-wrapper {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    height: 100%;
    padding: 1rem 4rem;
}

.theme-grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(430px, 1fr));
    gap: 1.5rem;
    width: 100%;
}

.grid-card {
    background-color: #FFFFFF1F;
    border: 1px solid #FFFFFF1F;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    /* Ensures the card fills the grid cell vertically */
    position: relative;
}

.grid-card.active {
    position: relative;
    overflow: visible;
    background: var(--primary-gradient-with-black) padding-box, var(--primary-gradient) border-box;
    border: 2px solid transparent;
    border-radius: 12px;
    background-clip: padding-box, border-box;
}

.selected-txt {
    position: absolute;
    top: -12px;
    left: 23px;
    color: #FFFFFF;
    z-index: 10;
    padding: 0.1rem 1.5rem;
    border-radius: 25rem;
    background: var(--primary-gradient);
    font-size: 12px;
}

.theme-title {
    padding: 1rem 1.5rem;
    font-weight: 600;
    letter-spacing: 0.2px;
    font-size: var(--normal-font-size);
    font-family: 'Inter';
    color: var(--secondary-font-color);
}

.theme-value {
    padding: 0rem 1.5rem;
    color: var(--secondary-font-color);
    font-size: 16px;
    font-family: 'Inter';
    letter-spacing: 0.2px;
}

.theme-top {
    flex-grow: 1;
}

.theme-bottom {
    border-top: 1px solid #FFFFFF33;

    padding: 1rem 0rem;
}

.theme-cta {

    padding: 0rem 1.5rem;
    color: var(--secondary-font-color);
    font-size: 16px;
    font-family: 'Inter';
    letter-spacing: 0.2px;
}

.theme-description {
    padding: 1rem 1.5rem;
    color: #FFFFFFCC;
    font-size: 14px;
    font-family: 'Inter';
    letter-spacing: 0.2px;
}
</style>